import { render, staticRenderFns } from "./Familienangaben.vue?vue&type=template&id=e17cc5fc"
import script from "./Familienangaben.vue?vue&type=script&lang=js"
export * from "./Familienangaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports